/**
 * Оттенок страницы от погоды. Температура ведёт тон, облачность — насыщенность.
 * Возвращаем составляющие, а не готовый цвет: тема сама решает, насколько
 * плотно его положить, иначе тёмная тема выцветает, а светлая мутнеет.
 */
export function moodHue(temp: number, cloud: number): { hue: number; sat: number } {
  const hue = temp <= -10 ? 212 : temp >= 32 ? 24 : 212 - ((temp + 10) / 42) * 188;
  const sat = Math.round(22 + (1 - cloud / 100) * 46);
  return { hue: Math.round(hue), sat };
}
